import { DefaultService } from '@/services/DefaultService';


export default class AssFornecedorRestricaoClienteService extends DefaultService {
    constructor(http, router, env) {
		super(http, router, env);
	}

    findAllVendas(column, order, page, limit, situacao, idcliente, ...params) {
        return this._http.get( encodeURI(`${this._env}/ven/cliente/restricao-fornecedor.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idcliente=${idcliente}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    findAllAgro(column, order, page, limit, situacao, idcliente, ...params) {
        return this._http.get( encodeURI(`${this._env}/agro/cliente/restricao-fornecedor.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idcliente=${idcliente}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    findVendas(id) {
		return this._http.get(`${this._env}/ven/cliente/restricao-fornecedor/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    findAgro(id) {
		return this._http.get(`${this._env}/agro/cliente/restricao-fornecedor/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    updateSituacaoVendas(fornecedorrestricao) {
        return this._http.post(`${this._env}/ven/cliente/restricao-fornecedor/updatesituacao`, fornecedorrestricao, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacaoAgro(fornecedorrestricao) {
        return this._http.post(`${this._env}/agro/cliente/restricao-fornecedor/updatesituacao`, fornecedorrestricao, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findNaoAssociadosVendas(column, order, page, limit, idcliente, ...params) {
        return this._http.get( encodeURI(`${this._env}/ven/cliente/restricao-fornecedor/naoassociado?page=${page}&limit=${limit}&column=${column}&order=${order}&idcliente=${idcliente}&param=${params}`), this._headers ).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findNaoAssociadosAgro(column, order, page, limit, idcliente, ...params) {
        return this._http.get( encodeURI(`${this._env}/agro/cliente/restricao-fornecedor/naoassociado?page=${page}&limit=${limit}&column=${column}&order=${order}&idcliente=${idcliente}&param=${params}`), this._headers ).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveVendas(fornecedorrestricao) {
        return this._http.post(`${this._env}/ven/cliente/restricao-fornecedor`, fornecedorrestricao, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveAgro(fornecedorrestricao) {
        return this._http.post(`${this._env}/agro/cliente/restricao-fornecedor`, fornecedorrestricao, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveAss(fornecedorrestricao) {
        return this._http.post(`${this._env}/ven/cliente/restricao-fornecedor/save`, fornecedorrestricao, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

}